import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45not_45found_45global from "/opt/buildhome/repo/middleware/00.not-found.global.ts";
import _01_45seo_45locale_45global from "/opt/buildhome/repo/middleware/01.seo-locale.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _00_45not_45found_45global,
  _01_45seo_45locale_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/opt/buildhome/repo/middleware/admin.ts"),
  settings: () => import("/opt/buildhome/repo/middleware/settings.ts")
}